// Append new dated versions. Never edit a version used by an issued invoice.
const originalVersion = [
  {
    validFrom: '2026-10-01',
    legalName: 'D N M LOGISTICS',
    tradeName: 'DNM Logistics',
    gstin: '36AATFD6879R1Z1',
    pan: 'AATFD6879R',
    addressLines: ['Plot No 32, Gandimaisamma Road, Medchal, Hyderabad 501401'],
    officeAddress:
      'Plot No 32, Gandimaisamma Road, Near Indian Oil Petrol Pump, Medchal, Hyderabad, Medchal Malkajgiri District, Telangana 501401',
    stateName: 'Telangana',
    stateCode: '36',
    email: 'dnmlogisticsofficial@gmail.com',
    phone: '8522803275',
    logo: '/assets/dnm-logo-light.png',
    bank: {
      name: 'HDFC Bank',
      branch: 'West Marredpally, Secunderabad 500026, Telangana',
      accountName: 'D N M LOGISTICS',
      accountNumber: '50200068470437',
      ifsc: 'HDFC0000377',
      upiId: '8522803271dnm@ybl',
    },
    sac: '996511',
    terms: [
      '1. Kindly make the payment to M/s DNM LOGISTICS.',
      '2. By Account IMPS, RTGS, Payee cheque / Demand draft favouring the company. Cash payment are not accepted.',
      '3. E-mail: dnmlogisticsofficial@gmail.com · Mob No. 8522803275',
    ],
    signature: undefined as string | undefined,
    signatoryLabel: 'Authorised Signatory',
    footerNote: 'This is a computer-generated invoice',
  },
];
// Owner supplied this asset on 2026-10-06; earlier issued versions retain their original branding.
export const invoiceTemplateVersions = [
  ...originalVersion,
  {
    ...originalVersion[0],
    validFrom: '2026-10-06',
    signature: '/assets/dnm-authorised-signatory-2026-10-06.png',
  },
];
export type InvoiceTemplate = (typeof invoiceTemplateVersions)[number];

// Owner-approved presentation asset applies to existing document views as well.
// Frozen legal/bank/terms versions and financial snapshots remain unchanged.
export const approvedSignatoryAsset = '/assets/dnm-authorised-signatory-2026-10-06.png';
